import { render, staticRenderFns } from "./ContentsList.vue?vue&type=template&id=27bc4f5e&scoped=true&"
import script from "./ContentsList.vue?vue&type=script&lang=js&"
export * from "./ContentsList.vue?vue&type=script&lang=js&"
import style0 from "./ContentsList.vue?vue&type=style&index=0&id=27bc4f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc4f5e",
  null
  
)

export default component.exports